<script src="../../../../../../../Downloads/html5酷炫3D球形文字云动画特效/js/modernizr.min.js"></script>
<template>
  <div class="container">
    <div class="top">
      <span>长按图片保存到相册，快去分享到朋友圈吧~</span>
      <img src="https://img-cdn1.ylyk.com/image/1638526222216_m1638526142068_s1754.jpg" alt="" />
    </div>
    <div class="main">
      <img
        class="decorate-circle-1"
        src="https://img-cdn1.ylyk.com/image/1638774210959_m1638774027617_s6597.jpg"
        alt=""
      />
      <div class="pic-main">
        <img class="decorate-l" src="https://img-cdn1.ylyk.com/image/1638526222216_m1638526108297_s999.jpg" alt="" />
        <div id="capture" class="pic-wrapper">
          <img class="cover" @load="onImageLoad" crossorigin="anonymous" :src="bgUrl" alt="" v-if="showBg" />
          <img class="avatar" :src="headUrl" v-if="showBg" alt="" />
          <div class="nickName" v-if="showBg">{{ nickName }}</div>
          <img class="cover" crossorigin="anonymous" :src="coverUrl" alt="" />
        </div>
        <img class="decorate-r" src="https://img-cdn1.ylyk.com/image/1638526222216_m1638526142057_s900.jpg" alt="" />
      </div>
      <video class="video" controls="controls" :src="videoUrl" poster=""></video>
      <div class="banner-title">
        <img src="https://img-cdn1.ylyk.com/image/1638526222216_m1638526108293_s642.jpg" alt="" />
        <span>YLYK - 2023专享训练营↓</span>
        <img src="https://img-cdn1.ylyk.com/image/1638526222216_m1638526108293_s669.jpg" alt="" />
      </div>
      <img class="banner" @click="onBannerClick" :src="bannerUrl" />
    </div>
    <img
      class="floating"
      @click="onFloatClick"
      src="https://img-cdn1.ylyk.com/image/1638526222216_m1638526108346_s7017.jpg"
      alt=""
    />
    <div class="animate-mask" v-if="showanimate">
      <div class="wordCloud__tagBall" :style="{ width: `${this.width}px`, height: `${this.height}px` }">
        <span
          class="wordCloud__tag"
          v-for="(item, index) of data"
          :key="index"
          :style="{ color: color[index % color.length], ...contentEle[index].style }"
        >
          {{ item }}
        </span>
      </div>
      <button class="btn_detail">立即抽取</button>

      <div class="note">活动介绍</div>
    </div>
  </div>
</template>

<script>
import { appUser, storage } from '@/utils'
import html2canvas from 'html2canvas'
import { AsyncRequest } from '@/utils/request'
import { pullnewService } from '@/api'

export default {
  name: 'pullnew-detail',
  data() {
    return {
      bgUrl: '',
      headUrl: '',
      coverUrl: '',
      videoUrl: '',
      bannerUrl: '',
      campUrl: '',
      nickName: '',
      showBg: true,
      showanimate: true,
      color: ['#ffffff'],
      contentEle: [],
      width: 300,
      height: 300,
      direction: '-3',
      speed: 100
    }
  },
  created() {
    this.width = document.body.clientWidth - 100
    this.height = this.width
    // this.data = ['Resilience', 'Improvisation', 'Listening', 'Conversation', 'Cooperation', 'Introspection', 'focus', 'inclusiveness', 'connectedness', 'normalcy',
    //   'decency', 'discipline', 'healing', 'idealism', 'love', 'relaxation', 'forgiveness', 'Doubt', 'Insensitivity', 'resolution',
    //   'heroism', 'melody', 'colors', 'smile', 'humbleness', 'humor', 'Excellence', 'rebirth', 'Closure', 'pursuit', 'caring']

    this.data = [
      '睡眠自由',
      '拥有幸福',
      '自洽',
      '心有所爱',
      '搞对象',
      '被宠爱',
      '做个勇士',
      '表达自我',
      '爱自己',
      '不再瞎想',
      '快意人生',
      '笑对人生',
      '哈哈哈',
      '做点傻事',
      '不emo',
      '占领快乐',
      '保持童心',
      '情绪稳定',
      '水逆退散',
      '享受慢时光',
      '躺赢',
      '活在当下',
      '减少内耗',
      '向前看',
      '拒绝内卷',
      '接受变化',
      '顺势而为',
      '放轻松',
      '升职加薪',
      '捂紧钱袋',
      '暴富',
      '搞钱',
      '过关斩将',
      '魅力四射',
      '全情投入',
      '元气满满',
      '告别拖延',
      '不再犹豫',
      '蓬勃生长',
      '保持好奇',
      '不将就',
      '去冒险',
      '充电',
      '一路向前',
      '干票大的'
    ]

    this.contentEle = this.data.map(() => ({
      x: 0,
      y: 0,
      z: 0,
      style: {}
    }))

    this.getPullNewDetailData()
    this.headUrl = appUser.avtarUrl
    this.nickName = appUser.nickName
    if (!this.headUrl) {
      const wxUser = storage.AppWeixinKey().getItem()
      this.headUrl = wxUser.avtarUrl
    }
    if (!this.nickName) {
      const wxUser = storage.AppWeixinKey().getItem()
      this.nickName = wxUser.nickName
    }
  },
  mounted() {
    this.innit()
  },
  methods: {
    onImageLoad() {
      this.createImage()
    },
    createImage() {
      const capture = document.getElementById('capture')
      console.log('capture', capture.offsetWidth, capture.offsetHeight)
      html2canvas(capture, {
        useCORS: true,
        width: capture.offsetWidth - 10,
        height: capture.offsetHeight - 16,
        scale: 2
      }).then(canvas => {
        // document.body.appendChild(canvas)
        const dataURL = canvas.toDataURL('image/png')
        // console.log('dataUrl', dataURL)
        this.coverUrl = dataURL
        this.showBg = false
        setTimeout(h => {
          this.showanimate = false
        }, 1000)
      })
    },
    onBannerClick() {
      location.href = this.campUrl
    },
    onFloatClick() {
      location.href = this.campUrl
    },
    getPullNewDetailData() {
      const wxUser = storage.AppWeixinKey().getItem()
      console.log('getPullNewDetailData=appUser', appUser)
      console.log('getPullNewDetailData=wxUser', wxUser)
      AsyncRequest({
        loading: true,
        request: () => pullnewService.pullnewDetail({ openId: wxUser.openId }),
        resolve: res => {
          // console.log('getPullNewDetailData=res', res)
          this.bgUrl = res.imageUrl
          this.videoUrl = res.videoUrl
          this.bannerUrl = res.bannerUrl
          this.campUrl = res.bannerUrlHref
        },
        reject(reason) {
          console.log('getPullNewDetailData=err', reason)
        }
      })
    },

    innit() {
      const RADIUSX = (this.width - 50) / 2
      const RADIUSY = (this.height - 50) / 2
      this.contentEle = []
      for (let i = 0; i < this.data.length; i += 1) {
        const k = -1 + (2 * (i + 1) - 1) / this.data.length
        const a = Math.acos(k)
        const b = a * Math.sqrt(this.data.length * Math.PI)
        const x = RADIUSX * Math.sin(a) * Math.cos(b)
        const y = RADIUSY * Math.sin(a) * Math.sin(b)
        const z = RADIUSX * Math.cos(a)
        const singleEle = {
          x,
          y,
          z,
          style: {}
        }
        this.contentEle.push(singleEle)
      }
      this.animate()
    },
    animate() {
      this.rotateX()
      this.rotateY()
      this.move()
      window.requestAnimationFrame(this.animate)
    },
    rotateX() {
      const angleX = ['-1', '1'].includes(this.direction)
        ? Math.PI / Infinity
        : Math.PI / ((Number(this.direction) / 2) * Number(this.speed))
      const cos = Math.cos(-angleX)
      const sin = Math.sin(-angleX)
      this.contentEle = this.contentEle.map(t => {
        const y1 = t.y * cos - t.z * sin
        const z1 = t.z * cos + t.y * sin
        return {
          ...t,
          y: y1,
          z: z1
        }
      })
    },
    rotateY() {
      const angleY = ['-2', '2'].includes(this.direction)
        ? Math.PI / Infinity
        : Math.PI / (Number(this.direction) * Number(this.speed))
      const cos = Math.cos(angleY)
      const sin = Math.sin(angleY)
      this.contentEle = this.contentEle.map(t => {
        const x1 = t.x * cos - t.z * sin
        const z1 = t.z * cos + t.x * sin
        return {
          ...t,
          x: x1,
          z: z1
        }
      })
    },
    move() {
      const CX = this.width / 2
      const CY = this.height / 2
      this.contentEle = this.contentEle.map(singleEle => {
        const { x, y, z } = singleEle
        const fallLength = this.width
        const RADIUS = (this.width - 50) / 2
        const scale = fallLength / (fallLength - z)
        const alpha = (z + RADIUS) / (2 * RADIUS)
        const left = `${x + CX - 15}px`
        const top = `${y + CY - 15}px`
        const transform = `translate(${left}, ${top}) scale(${scale / 2})`
        const style = {
          ...singleEle.style,
          opacity: alpha + 0.5,
          zIndex: parseInt(scale * 100, 10),
          transform
        }
        return {
          x,
          y,
          z,
          style
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  background-color: #00002e;
  padding-bottom: 1.24rem;
  .top {
    display: flex;
    flex-flow: row;
    align-items: center;
    justify-content: center;
    background-color: #fcdccf;
    height: 0.72rem;
    font-size: 14px;
    color: black;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    img {
      width: 0.39rem;
      height: 0.48rem;
      margin-left: 0.24rem;
    }
  }
  .main {
    width: 100%;
    height: auto;
    position: relative;
    margin-top: 0.72rem;
    .pic-main {
      display: flex;
      flex-flow: row;
      position: relative;
      .decorate-l {
        width: 0.2rem;
        height: 1.1rem;
        margin-top: 0.48rem;
        margin-left: 0.16rem;
      }
      .decorate-r {
        width: 0.16rem;
        height: 0.92rem;
        margin-right: 0.2rem;
        position: absolute;
        bottom: 0.1rem;
        right: 0;
      }
      .pic-wrapper {
        position: relative;
        margin-top: 0.48rem;
        margin-left: 0.28rem;
        margin-right: 0.48rem;
        background-color: rgba(105, 228, 244, 0.18);
        width: 100%;
        .cover {
          width: 100%;
          display: block;
          float: right;
          margin-right: 8px;
          margin-bottom: 8px;
          margin-top: -8px;
        }
        .avatar {
          border-radius: 50%;
          position: absolute;
          width: 0.96rem;
          height: 0.96rem;
          top: 0.15rem;
          left: 0.15rem;
        }
        .nickName {
          position: absolute;
          top: 0.47rem;
          left: 1.2rem;
          color: white;
          font-size: 0.32rem;
        }
      }
    }
    .video {
      margin-top: 0.68rem;
      padding-left: 0.48rem;
      padding-right: 0.48rem;
      width: 100%;
    }
    .banner-title {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 0.72rem;
      color: #69e4f4;
      font-size: 0.26rem;
      margin-left: 0.48rem;
      margin-right: 0.48rem;
      img {
        width: 1.6rem;
        height: 0.48rem;
      }
    }
    .banner {
      width: 100%;
      height: 2.26rem;
      margin-top: 0.44rem;
      display: block;
      padding-left: 0.48rem;
      padding-right: 0.48rem;
    }
    .decorate-circle-1 {
      width: 3.12rem;
      height: 4.12rem;
      position: absolute;
      left: 0;
      top: 5rem;
    }
  }
  .floating {
    position: fixed;
    bottom: 1.08rem;
    right: 0.4rem;
    width: 1.5rem;
    height: 1.5rem;
  }
  .animate-mask {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 9999;
    background-image: url('https://img-cdn1.ylyk.com/image/1638526222216_m1638527370078_s141.jpg');
    background-color: #00002e;
    text-align: center;
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    .wordCloud__tagBall {
      margin: 50px auto;
      position: relative;
      background-image: url('https://img-cdn1.ylyk.com/image/1638526222216_m1638526143061_s44102.jpg');
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    .wordCloud__tag {
      display: block;
      position: absolute;
      left: 0;
      top: 0;
      color: green;
      text-decoration: none;
      font-size: 0.2rem;
      font-family: '微软雅黑', serif;
      overflow: -webkit-marquee;
      white-space: nowrap;
      width: 20px;
      -webkit-marquee-direction: left;
      -webkit-marquee-speed: normal;
      -webkit-marquee-style: scroll;
      -webkit-marquee-repetition: infinite;
      & > hover {
        color: red;
      }
    }
    .btn_detail {
      color: white;
      background-color: #00b25a;
      padding: 0.2rem 1rem;
      border-radius: 0.4rem;
      opacity: 0;
    }
    .note {
      text-decoration: underline;
      color: #00c0ad;
      margin-top: 1.58rem;
      opacity: 0;
    }
  }
}
</style>
